module.exports = __webpack_public_path__ + "media/images/HideBalance-f8843453.svg";